import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import SpeakersList from './SpeakersList';

const styles = css`
padding: 45px 0 30px 0;
position: relative;
@media (min-width: 992px) {
  padding: 120px 0 60px 0;
  background-image: url('/images/homebuilder-tech-logo.png');
  background-position: 70vw -10vh;
  background-size: 60vh auto;
  background-repeat: no-repeat;
}
`;

function Speakers({ page, widget }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader />
      <div className={styles}>
        <div className="container">
          <SpeakersList speakers={get(widget, 'speakers', [])} />
        </div>
      </div>
    </PageWrapper>
  );
}

Speakers.propTypes = {
  page: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  page: 'speakers',
  widget: 'speakers',
})(Speakers);



// WEBPACK FOOTER //
// ./src/pages/Speakers/index.js